/* eslint-disable no-param-reassign */
// using recommended approach @see https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/custom/#processevent
import type { IntegrationFn } from '@sentry/core'

const localStorageIntegration: IntegrationFn = () => ({
  name: 'LocalStorageIntegration',
  processEvent: async (event) => {
    try {
      const localStorageRaw = Object.entries(window.localStorage)
      const localStorageParsed = localStorageRaw.map(([k, v]) => {
        try {
          return [k, JSON.parse(v)]
        } catch (e) {
          return [k, v]
        }
      })

      event.extra = {
        ...event.extra,
        localStorage: Object.fromEntries(localStorageParsed),
      }
    } catch (e) {
      event.extra = { ...event.extra, localStorageError: e }
    }
    return event
  },
})

export { localStorageIntegration }
